import "@hotwired/turbo";

import "./controllers/index";

import { onDocumentReady, addEventSelectorListener, Carousel, Slider } from "@story/story_assets";
import "@story/story_assets/slide";
import "@story/story_assets/modal/modal_gallery";
import "@story/story_assets/slider";
import "@story/story_assets/ajax_form";

import "./components/navigation"
import "./components/multiselect";
import "./components/instareels";
import "./components/forms";

// import { init } from "aos"
// init();

// document.addEventSelectorListener("click", "[data-instant-show]", (event, target) => {
// 	event.preventDefault();
// 	for (const element of document.querySelectorAll(target.getAttribute("data-instant-show"))) {
// 		element.classList.remove("d-none");
// 	}
// });

// document.addEventSelectorListener("click", "[data-instant-hide]", (event, target) => {
// 	event.preventDefault();
// 	for (const element of document.querySelectorAll(target.getAttribute("data-instant-hide"))) {
// 		element.classList.add("d-none");
// 	}
// });

onDocumentReady(() => {
	for (const element of document.querySelectorAll(".carousel")) {
		new Carousel(element);
	};

	for (const element of document.querySelectorAll(".slider")) {
		new Slider(element);
	};
});


// const loadButton = document.getElementById("load-more")
// const cards = document.querySelectorAll(".col-product-card.pagg")

// let paggination = 1;
// let visibleCardsCount = 2;


// loadButton.addEventListener("click", function(event) {
//     event.preventDefault();
// 	loadMore();
// 	console.log(visibleCardsCount)
// });



// function loadMore() {
// 	const cardsToShow = Array.from(cards).slice(0, visibleCardsCount + paggination);
// 	cardsToShow.forEach(card => {
// 		card.classList.remove("hidden")
// 		visibleCardsCount += paggination
// 	})

// }

// window.onload = function() {
// 	if (loadButton && cards){
// 		loadMore();
// 	}
// }
